import { createAction } from 'typesafe-actions';

import { EInputType } from 'shared/types/filters/inputType';

export const changeInputTypeAction = createAction(
  'filters/inputTypeChanged',
  (event: React.ChangeEvent<HTMLInputElement>) => Number(event.target.value),
)<EInputType>();
